import { ref } from "vue";
import { Api, DisplayAuditLogDto } from "@evidence/sdk";

export default function useAuditLogs() {
  const auditLogs = ref<DisplayAuditLogDto[]>([]);
  const loading = ref(false);
  const error = ref<string | null>(null);
  const total = ref(0);
  const currentPage = ref(1);
  const pageSize = ref(10);

  const api = new Api();

  async function fetchAuditLogs(projectId?: number, page = 1, size = 10) {
    loading.value = true;
    error.value = null;
    currentPage.value = page;
    pageSize.value = size;

    try {
      const response = await api.api.auditLogsControllerFind({
        page,
        pageSize: size,
        projectId,
      });
      auditLogs.value = response.data.auditLogs;
      total.value = response.data.total;
    } catch (e) {
      error.value = "Failed to fetch audit logs";
      console.error(e);
    } finally {
      loading.value = false;
    }
  }

  return {
    auditLogs,
    loading,
    error,
    total,
    currentPage,
    pageSize,
    fetchAuditLogs,
  };
}
